<template>
  <div v-if="scrolled" class="to-top" @click="toTop"></div>
</template>
<script>
export default {
  data(){
    return {
      scrolled:false
    }
  },
  mounted() {
    const _this = this
    window.onscroll = function (){
      _this.handle()
    }
  },
  methods:{
   handle(){
     this.scrolled = document.documentElement.scrollTop>100
   },
   toTop(){
     document.body.scrollTop = document.documentElement.scrollTop = 0
   }
  }
}
</script>
